// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".remove-translation-modal {\n    width: 400px;\n    margin: 250px auto 0;\n}\n.remove-translation-wrapper {\n    margin: 15px 0;\n    display: flex;\n}\n.remove-translation-wrapper .font-awesome-icon {\n    padding-top: 3px;\n}\n.remove-translation-text {\n    margin-left: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
